angular.module("iFAST.common")
.factory("showPasswordChangeConfirmation", [function () {
    "use strict";
    var openModal = function (ctrl) {
    	ctrl.modal.open({
			templateUrl: require("../../directives/ifastMessage/messageConfirm.tpl.html"),
			controller: [ "$scope", "$uibModalInstance", function showPasswordChangeConfirmationModalController( $scope, $modalInstance) {
				$scope.ifastMessageConfirmCtrl = ctrl;
				ctrl.closeModal = function () {
					ctrl.onCancel();
					$modalInstance.dismiss("cancel");
				};
				
			}],
			controllerAs: "ifastMessageConfirmCtrl",
			
			backdrop: "static",
			size: "sm",
			windowClass: "xs-sm-modal",
			keyboard: false
		});
    };
   
    return {
    	openModal: openModal
    };
}]);


// WEBPACK FOOTER //
// ./WebContent/src/_common/services/shared/ifast-common-service.js